import { render, staticRenderFns } from "./logo-bose.vue?vue&type=template&id=61f8e6bc&scoped=true&"
import script from "./logo-bose.vue?vue&type=script&lang=js&"
export * from "./logo-bose.vue?vue&type=script&lang=js&"
import style0 from "./logo-bose.vue?vue&type=style&index=0&id=61f8e6bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f8e6bc",
  null
  
)

export default component.exports